import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/Auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Capture from "@/pages/Capture";
import CaptureProgress from "@/pages/CaptureProgress";
import Batch from "@/pages/Batch";
import BatchReview from "@/pages/BatchReview";
import Contacts from "@/pages/Contacts";
import ContactDetail from "@/pages/ContactDetail";
import Composer from "@/pages/Composer";
import Templates from "@/pages/Templates";
import Campaigns from "@/pages/Campaigns";
import CampaignNew from "@/pages/CampaignNew";
import CampaignDetail from "@/pages/CampaignDetail";
import Events from "@/pages/Events";
import Senders from "@/pages/Senders";
import FollowUps from "@/pages/FollowUps";
import Settings from "@/pages/Settings";
import More from "@/pages/More";
import { AuthCallback } from "@/components/GoogleAuth";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="flex h-screen items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Home />} />
            <Route path="/capture" element={<Capture />} />
            <Route path="/captures/:id" element={<CaptureProgress />} />
            <Route path="/batch" element={<Batch />} />
            <Route path="/batch/:id" element={<BatchReview />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/contacts/:id" element={<ContactDetail />} />
            <Route path="/compose" element={<Composer />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/campaigns/new" element={<CampaignNew />} />
            <Route path="/campaigns/:id" element={<CampaignDetail />} />
            <Route path="/events" element={<Events />} />
            <Route path="/senders" element={<Senders />} />
            <Route path="/followups" element={<FollowUps />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/more" element={<More />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
